import { CanDeactivateFn } from '@angular/router';
import { DialogService } from '../services/dialog.service';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';
import { ExportRequestFormModificationTrackerService } from '../services/export-request-form-modification-tracker.service';

export interface CanComponentDeactivate {
  canDeactivate: () => boolean;
}

export const pendingExportRequestChangesGuard: CanDeactivateFn<CanComponentDeactivate> = (component, currentRoute, currentState, nextState) => {
  const dialogService = inject(DialogService);
  const translateService = inject(TranslateService);
  const formModificationTrackerService = inject(ExportRequestFormModificationTrackerService);
  
  if (nextState?.url.startsWith(currentState.url) || (!formModificationTrackerService.isModified())) {
    return true;
  }

  return dialogService.openConfirm({
    message: translateService.instant('dialog-message.unsaved-changes-guard'),
    yesButtonLabel: translateService.instant('action.continue'),
    noButtonLabel: translateService.instant('action.exit')
  }).pipe(map(response => !response.accept));
};

